import React from 'react';
import {Download} from 'lucide-react';

import {Button} from '../components/ui/button';

/**
 * Properties needed to render a media message.
 */
export type MediaMessageProps = {
  mimeType: string;
  url: string;
  name: string;
};

/**
 * Trigger a download of the given URL.
 */
const download = (url: string, name: string) => {
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

/**
 * Render an MMS message.
 */
export const MediaMessage = ({url, mimeType, name}: MediaMessageProps) => {
  switch (mimeType) {
    case 'image/jpeg':
    case 'image/jpg':
    case 'image/gif':
    case 'image/png':
      return (
        <img
          src={url}
          alt={name}
          className="max-w-[200px] rounded-lg"
          style={{maxHeight: '200px', objectFit: 'contain'}}
        />
      );
    default:
      // If we can't display the file directly, render a download button.
      // TODO: We can support more media types if there's demand.
      return (
        <Button
          variant="outline"
          onClick={() => download(url, name)}
          className="flex items-center gap-2"
        >
          <Download className="h-4 w-4" />
          Download media attachment
        </Button>
      );
  }
};
